import { useMemo, useState } from "react";
import { ExternalLink, UploadIcon } from "lucide-react";

import { Button, TabsV2 } from "@/modules/common/components";
import { useSessionStore } from "@/modules/auth/store/useSessionStore";
import { AdminUserRole } from "@/modules/common/types/Users.enum";

import { ANEEL_PORTAL_URL } from "./constants/AneelPortal";
import useAneelTariffLastUpdate from "./hooks/useAneelTariffLastUpdate";
import LastUpdateCard from "./components/LastUpdateCard";
import TariffsTab from "./components/TariffsTab";
import ImportHistoryTab from "./components/ImportHistoryTab";
import ImportAneelTariffsModal from "./components/ImportAneelTariffsModal";

const AneelTariffs = () => {
  const { canUserSee } = useSessionStore();
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const { data: lastUpdate, isLoading: isLastUpdateLoading, isError: isLastUpdateError } = useAneelTariffLastUpdate();

  const TAB_DATA = useMemo(
    () => [
      { key: "tarifas", label: "Tarifas", content: <TariffsTab /> },
      { key: "historico", label: "Histórico de Importações", content: <ImportHistoryTab /> },
    ],
    [],
  );

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-col">
          <p className="text-[22px] font-bold text-ui-primary">Tarifas ANEEL</p>
          <p className="text-[14px] text-ui-text-muted">
            Importe os arquivos de tarifas homologadas pela ANEEL e consulte as tarifas disponíveis na plataforma.
          </p>
        </div>

        <div className="flex flex-col gap-2 md:flex-row">
          <Button
            variant="outlined"
            label="Acessar Portal ANEEL"
            className="w-full md:w-auto"
            icon={<ExternalLink className="h-4 w-4" />}
            onClick={() => window.open(ANEEL_PORTAL_URL, "_blank", "noopener,noreferrer")}
          />

          {canUserSee(AdminUserRole.ADMIN) && (
            <Button
              label="Importar arquivo"
              icon={<UploadIcon />}
              className="w-full md:w-auto"
              onClick={() => setIsImportModalOpen(true)}
            />
          )}
        </div>
      </div>

      <LastUpdateCard data={lastUpdate} isLoading={isLastUpdateLoading} isError={isLastUpdateError} />

      <TabsV2 defaultValue="tarifas" tabData={TAB_DATA} />

      <ImportAneelTariffsModal open={isImportModalOpen} onOpenChange={setIsImportModalOpen} />
    </div>
  );
};

export default AneelTariffs;
